<template>
  <div>
    <AddOrEditCatalogHeader
      @createNewVehicle="createNewVehicle"
      @editVehicle="editVehicle"
      @exitEditing="exitEditing"
      @setValueFilterWhenCancel="setValueFilterWhenCancel"
      :vehicleSelected="vehicleSelected"
    >
    </AddOrEditCatalogHeader>
    <!-- Card Vehículo -->
    <div class="d-flex justify-space-between form-container direction">
      <div class="d-flex flex-column left-side">
        <v-card
          outlined
          color="grey lighten-4"
          class="pa-6 ma-4 d-flex flex-column justify-start">
          <v-card-title class="text-uppercase text-no-wrap font-weight-bold align-self-start pb-4 pl-6">DATOS DEL VECHÍCULO</v-card-title>
          <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete
                    class="mx-6"
                    v-model="brandSelected"
                    :items="brandItems"
                    label="Marca del vehículo"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    class="mx-6"
                    v-model="lineSelected"
                    :items="lineItems"
                    label="Línea del vehículo"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <v-text-field
                    class="ml-6"
                    v-model="vehicleSelected.code"
                    label="Código"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="ml-6"
                    v-model="vehicleSelected.model"
                    label="Modelo"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    class="mx-6"
                    v-model="fuelSelected"
                    :items="fuelTypes"
                    label="Tipo de combustible"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    class="ml-6"
                    v-model="vehicleSelected.doors"
                    label="Puertas"
                    type="number"
                    min="2"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="ml-6"
                    v-model="vehicleSelected.stock"
                    label="Stock"
                    type="number"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          color="grey lighten-4"
          class="pa-6 ma-4 d-flex flex-column justify-start">
          <v-card-title class="text-uppercase text-no-wrap font-weight-bold align-self-start pb-4 pl-6">COLORES DISPONIBLES</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="color in allColors"
                :key="'color-' + color.id"
                cols="3"
              >
                <v-checkbox
                  v-model="colorListSelected"
                  :key="'color-check-' + color.id"
                  :value="color.id"
                >
                  <template v-slot:label>
                    <v-avatar
                      :color="color.codigo"
                      :size="24"
                      class="elevation-3"
                    />
                    {{ color.color}}
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <div class="d-flex flex-column right-side">
        <v-card
          color="grey lighten-4"
          class="pa-6 ma-4 d-flex flex-column justify-start"
          elevation="0">
          <v-card-title class="text-uppercase text-no-wrap font-weight-bold align-self-start pb-4">PRECIO</v-card-title>
          <v-card-text class="pb-8">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.list_price"
                  @change="applyFilterTransformData(vehicleSelected.list_price, 'list_price', 'magnitude')"
                  @focus="applyFilterTransformData(vehicleSelected.list_price, 'list_price', 'number')"
                  label="Precio lista"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.rasa_bonification"
                  @change="applyFilterTransformData(vehicleSelected.rasa_bonification, 'rasa_bonification', 'magnitude')"
                  @focus="applyFilterTransformData(vehicleSelected.rasa_bonification, 'rasa_bonification', 'number')"
                  label="Rasa bonificación"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.net_price_renault"
                  @change="applyFilterTransformData(vehicleSelected.net_price_renault, 'net_price_renault', 'magnitude')"
                  @focus="applyFilterTransformData(vehicleSelected.net_price_renault, 'net_price_renault', 'number')"
                  label="Precio Neto Renault"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.lepic_bonification"
                  @change="applyFilterTransformData(vehicleSelected.lepic_bonification, 'lepic_bonification', 'magnitude')"
                  @focus="applyFilterTransformData(vehicleSelected.lepic_bonification, 'lepic_bonification', 'number')"
                  label="Bonificación Lepic"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.percentage_discount"
                  label="Porcentaje descuento"
                  suffix="%"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="vehicleSelected.lepic_price"
                  @change="applyFilterTransformData(vehicleSelected.lepic_price, 'lepic_price', 'magnitude')"
                  @focus="applyFilterTransformData(vehicleSelected.lepic_price, 'lepic_price', 'number')"
                  label="Precio Lepic"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import AddOrEditCatalogHeader from '@/components/catalog/AddOrEditCatalogHeader'
import initialStateConfig from '@/components/catalog/initialState'
import { getAllColorsByModel } from '@/services/vehicles'
import { createModel, updateModel } from '@/services/catalog'
import { mapState, mapGetters, mapActions } from 'vuex'
import AuthHelper from '@/helpers/AuthHelper'
import Helper from '@/helpers/Helper'

export default {
  name: 'AddOrEditCatalog',
  components: {
    AddOrEditCatalogHeader
  },
  props: {
    allModels: {
      type: Array,
      required: true
    },
    allStatuses: {
      type: Array,
      required: true
    },
    allVehicleTypes: {
      type: Array,
      required: true
    },
    allTransmitions: {
      type: Array,
      required: true
    },
    allBrands: {
      type: Array,
      required: true
    },
    allLines: {
      type: Array,
      required: true
    },
    allFuelTypes: {
      type: Array,
      required: true
    },
    allColors: {
      type: Array,
      required: true
    },
    vehicleToEdit: {
      type: Object
    }
  },
  data () {
    return {
      vehicleSelected: {
        id: '',
        year: '',
        vin_code: '',
        domain: '',
        adquisition_date: '',
        serial_number: '',
        mileage_km: '',
        list_price: '',
        rasa_bonification: '',
        net_price_renault: '',
        lepic_bonification: '',
        percentage_discount: '',
        lepic_price: '',
        status: '',
        location: '',
        transmition: '',
        type: '',
        color: '', // usar
        observations: '',
        model: '', // nuevo
        code: '', // nuevo
        doors: '', // nuevo
        stock: '' // nuevo
      },
      modelSelected: '',
      active: false,
      itemModels: [],
      locationItems: [],
      vehicleTypeItems: [],
      transmitionItems: [],
      modelsItems: [],
      statusesItems: [],
      colorItems: [],
      brandItems: [],
      lineItems: [],
      fuelTypes: [],
      colorListSelected: [],
      location: '',
      statusSelected: '',
      // vehicleTypeSelected: '',
      colorSelected: '',
      transmitionSelected: '',
      brandSelected: '',
      lineSelected: '',
      fuelSelected: '',
      isAdquisitionDateExpanded: false,
      allLocations: ''
    }
  },
  computed: {
    ...mapState(['userToken']),
    ...mapGetters(['editingCatalog'])
    /* accesoryModelsAdded () {
      return this.vehicleSelected.models.filter(a => !a.delete)
    } */
  },
  methods: {
    ...mapActions(['handleAlert', 'handleLoading']),
    applyFilterTransformData (value, field, filter) {
      this.vehicleSelected[field] = this.$options.filters[filter](value)
    },
    setValueFilter () {
      this.vehicleSelected.value = this.$options.filters.magnitude(this.vehicleSelected.value)
    },
    resetFilterToEditValue () {
      this.vehicleSelected.value = this.$options.filters.number(this.vehicleSelected.value)
    },
    setValueFilterWhenCancel () {
      this.$emit('setValueFilterWhenCancel')
    },
    toggleActive () {
      this.active = !this.active
    },
    transformArrayForAutocomplete (array, field) {
      const itemArray = []
      array.forEach(item => {
        itemArray.push({
          value: item.id,
          text: item[field]
        })
      })
      return itemArray
    },
    transformForSubmitVehicle (vehicle) {
      const data = {
        id: vehicle.id ? vehicle.id : null,
        model: vehicle.model,
        code: vehicle.code,
        vehicle_doors: vehicle.doors,
        quantity: vehicle.stock,
        vehicle_brand_id: this.brandSelected,
        vehicle_line_id: this.lineSelected,
        vehicle_fuel_id: this.fuelSelected,
        vehicle_color: this.colorListSelected,
        list_price: Number(this.$options.filters.number(vehicle.list_price)),
        rasa_bonification: Number(this.$options.filters.number(vehicle.rasa_bonification)),
        net_price_renault: Number(this.$options.filters.number(vehicle.net_price_renault)),
        lepic_bonification: Number(this.$options.filters.number(vehicle.lepic_bonification)),
        percentage_discount: vehicle.percentage_discount,
        lepic_price: Number(this.$options.filters.number(vehicle.lepic_price))
      }
      /*
      const data = {
        id: vehicle.id ? vehicle.id : null,
        year: vehicle.year,
        vin_code: vehicle.vin_code,
        domain: vehicle.domain,
        list_price: Number(this.$options.filters.number(vehicle.list_price)),
        rasa_bonification: Number(this.$options.filters.number(vehicle.rasa_bonification)),
        net_price_renault: Number(this.$options.filters.number(vehicle.net_price_renault)),
        lepic_bonification: Number(this.$options.filters.number(vehicle.lepic_bonification)),
        percentage_discount: vehicle.percentage_discount,
        lepic_price: Number(this.$options.filters.number(vehicle.lepic_price)),
        adquisition_date: vehicle.adquisition_date,
        serial_number: vehicle.serial_number,
        location: vehicle.location,
        mileage_km: Number(this.$options.filters.number(vehicle.mileage_km)),
        transmition_id: vehicle.transmition,
        vehicle_type_id: 1,
        vehicle_status_id: vehicle.status,
        vehicle_model_id: vehicle.model,
        vehicles_colors_id: vehicle.color !== '' ? vehicle.color : null,
        observations: vehicle.observations ? vehicle.observations : null
      }
      */
      return data
    },
    async createNewVehicle () {
      this.handleLoading(true)
      const data = await this.transformForSubmitVehicle(this.vehicleSelected)
      try {
        const res = await createModel(this.userToken, data)
        this.$store.dispatch('handleShowAddOrEditCatalog', false)
        this.$store.dispatch('handleEditCatalog', false)
        this.$emit('addModel', res.data.data)
        this.alertMessage = res.data.message
        this.alertColor = 'success'
        this.handleLoading(false)
      } catch (error) {
        AuthHelper.checkErrorExpiredToken(error)
        this.alertMessage = error?.data?.message ? error.data.message : error
        this.alertColor = 'error'
        this.handleLoading(false)
      } finally {
        this.exitEditing()
        this.handleAlert({
          value: true,
          text: this.alertMessage,
          color: this.alertColor
        })
      }
    },
    async editVehicle () {
      this.handleLoading(true)
      const data = this.transformForSubmitVehicle(this.vehicleSelected)
      this.handleLoading(false)
      // data.append('_method', 'PUT')
      try {
        const res = await updateModel(this.userToken, data, data.id)
        this.$store.dispatch('handleShowAddOrEditCatalog', false)
        this.$store.dispatch('handleEditCatalog', false)
        this.$emit('updateModel', res.data.data)
        this.editingVehicleSelected(false, this.vehicleSelected)
        this.alertMessage = res.data.message
        this.alertColor = 'success'
        this.handleLoading(false)
      } catch (error) {
        AuthHelper.checkErrorExpiredToken(error)
        this.alertMessage = error?.data?.message ? error.data.message : error
        this.alertColor = 'error'
        this.handleLoading(false)
      } finally {
        this.handleAlert({
          value: true,
          text: this.alertMessage,
          color: this.alertColor
        })
      }
    },
    async exitEditing () {
      this.editingVehicleSelected(false)
      this.$emit('stopEditing')
    },
    // refactorizar
    editingVehicleSelected (editing, prop) {
      if (editing) {
        this.vehicleSelected.id = prop.id
        if (Object.prototype.hasOwnProperty.call(prop, 'data')) {
          /*
          this.vehicleSelected.year = Object.prototype.hasOwnProperty.call(prop.data, 'year')
            ? prop.data.year : prop.year
          this.vehicleSelected.vin_code = Object.prototype.hasOwnProperty.call(prop.data, 'vin_code') ? prop.data.vin_code : prop.vin_code
          this.vehicleSelected.domain = prop.data.domain ? prop.data.domain : null
          this.vehicleSelected.adquisition_date = prop.data.adquisition_date ? prop.data.adquisition_date : null
          this.vehicleSelected.serial_number = prop.data.serial_number ? prop.data.serial_number : null
          this.vehicleSelected.mileage_km = prop.data.mileage_km ? prop.data.mileage_km : null
          this.vehicleSelected.list_price = prop.data.list_price ? prop.data.list_price : null
          this.vehicleSelected.rasa_bonification = prop.data.rasa_bonification ? prop.data.rasa_bonification : null
          this.vehicleSelected.net_price_renault = prop.data.net_price_renault ? prop.data.net_price_renault : null
          this.vehicleSelected.lepic_bonification = prop.data.lepic_bonification ? prop.data.lepic_bonification : null
          this.vehicleSelected.percentage_discount = prop.data.percentage_discount ? prop.data.percentage_discount : null
          this.vehicleSelected.lepic_price = prop.data.lepic_price ? prop.data.lepic_price : null
          this.vehicleSelected.location = prop.data.location ? prop.data.location : null
          this.vehicleSelected.transmition = prop.data.transmition ? prop.data.transmition : null
          this.vehicleSelected.color = prop.data.color ? prop.data.color : null
          this.vehicleSelected.type = prop.data.vehicle_type_id ? prop.data.vehicle_type_id : 1
          this.vehicleSelected.vehicle_type_id = prop.data.vehicle_type_id ? prop.data.vehicle_type_id : 1
          this.vehicleSelected.adquisition_date = prop.data.adquisition_date ? prop.data.adquisition_date : null
          this.vehicleSelected.serial_number = prop.data.serial_number ? prop.data.serial_number : null
          this.vehicleSelected.observations = prop.data.observations ? prop.data.observations : null
          this.modelSelected = prop.data.vehicle_model_id
          this.statusSelected = prop.data.vehicle_status_id
          this.colorSelected = prop.data.vehicles_colors_id
          this.transmitionSelected = prop.data.transmition_id
          */

          this.vehicleSelected.list_price = prop.data.list_price ? prop.data.list_price : null
          this.vehicleSelected.rasa_bonification = prop.data.rasa_bonification ? prop.data.rasa_bonification : null
          this.vehicleSelected.net_price_renault = prop.data.net_price_renault ? prop.data.net_price_renault : null
          this.vehicleSelected.lepic_bonification = prop.data.lepic_bonification ? prop.data.lepic_bonification : null
          this.vehicleSelected.percentage_discount = prop.data.percentage_discount ? prop.data.percentage_discount : null
          this.vehicleSelected.lepic_price = prop.data.lepic_price ? prop.data.lepic_price : null

          this.vehicleSelected.model = prop.data.model ? prop.data.model : null
          this.vehicleSelected.code = prop.data.code ? prop.data.code : null
          this.vehicleSelected.doors = prop.data.vehicle_doors ? prop.data.vehicle_doors : null
          this.vehicleSelected.stock = prop.data.quantity ? prop.data.quantity : null

          this.brandSelected = prop.data.vehicle_brand_id ? prop.data.vehicle_brand_id : null
          this.lineSelected = prop.data.vehicle_line_id ? prop.data.vehicle_line_id : null
          this.fuelSelected = prop.data.vehicle_fuel_id ? prop.data.vehicle_fuel_id : null

          prop.data.vehicle_color_ids.forEach((element) => {
            this.colorListSelected.push(element.vehicle_color_id)
          })
        }
        // this.vehicleSelected.domain = prop.domain
      } else {
        this.vehicleSelected = JSON.parse(JSON.stringify(initialStateConfig))
      }
    },
    async getColorsByModel (modelID) {
      try {
        this.handleLoading(true)
        const res = await getAllColorsByModel(this.userToken, modelID)
        this.colors = res.data.data
        this.colorItems = Helper.transformToSelect(this.colors, 'color')
        this.colorItems.forEach(ci => { ci.code = Helper.getItemFromArray(ci.value, this.colors)?.codigo })
        this.alertMessage = res.data.message
        this.alertColor = 'success'
      } catch (error) {
        AuthHelper.checkErrorExpiredToken(error)
        this.alertMessage = error?.data?.message ? error.data.message : error
        this.alertColor = 'error'
        this.colorItems = []
        this.data.color = ''
      } finally {
        this.handleLoading(false)
        this.handleAlert({
          value: true,
          text: this.alertMessage,
          color: this.alertColor
        })
      }
    }
  },
  async mounted () {
    this.modelsItems = Helper.transformToSelect(this.allModels, 'model')
    this.statusesItems = Helper.transformToSelect(this.allStatuses, 'name')
    this.transmitionItems = Helper.transformToSelect(this.allTransmitions, 'name')
    this.vehicleTypeItems = Helper.transformToSelect(this.allVehicleTypes, 'name')
    this.brandItems = Helper.transformToSelect(this.allBrands, 'brand')
    let brandRenualt = null
    this.brandItems.forEach((element, index) => {
      if (element.text === 'Renault') {
        brandRenualt = index
      }
    })
    if (brandRenualt !== null) {
      this.brandItems = [this.brandItems[brandRenualt]]
    }
    this.lineItems = Helper.transformToSelect(this.allLines, 'line')
    this.fuelTypes = Helper.transformToSelect(this.allFuelTypes, 'fuel')
    if (this.editingCatalog) {
      await this.editingVehicleSelected(this.editingCatalog, this.vehicleToEdit)
    }
  },
  watch: {
    accesoryModelsAdded: {
      deep: true,
      handler () {
        const accessoryModelsNotAddes = this.getAccesoryModelsNotAdded()
        this.itemModels = this.transformArrayForAutocomplete(accessoryModelsNotAddes, 'model')
      }
    },
    statusSelected: {
      deep: true,
      handler () {
        this.vehicleSelected.status = this.statusSelected
      }
    },
    colorSelected: {
      deep: true,
      handler () {
        this.vehicleSelected.color = this.colorSelected
      }
    },
    transmitionSelected: {
      deep: true,
      handler () {
        this.vehicleSelected.transmition = this.transmitionSelected
      }
    },
    modelSelected: {
      deep: true,
      handler () {
        this.vehicleSelected.modelCode = this.modelSelected
        this.getColorsByModel(this.modelSelected.value ? this.modelSelected.value : this.modelSelected)
      }
    },
    brandSelected: {
      deep: true,
      handler () {
        // this.lineSelected = ''
        const filteredLines = []
        this.allLines.forEach((element) => {
          if (element.vehicles_brands_id === parseInt(this.brandSelected)) {
            filteredLines.push(element)
          }
        })
        this.lineItems = Helper.transformToSelect(filteredLines, 'line')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  li {
    @include fontStyle(500, 14px, 0.01em, $black);
    list-style: none;
  }
}
.hr-style {
  border: 1px dashed rgba(157, 157, 157, 0.5);
}
.title_font {
  @include fontStyle(bold, 14px, 0.01em, $black)
}
.box-width {
  width: 100%;
}
.left-side {
  width: 70%;
  margin-left: 28px;
}
.right-side {
  width: 30%;
  margin-right: 28px;
}
.list-title_font {
  @include fontStyle(bold, 14px, 0.01em, $grey)
}
.drop-container {
  width: 100%;
}
.drop-area {
  border: 1px dashed $grey;
  width: 88%;
  height: 170px;
  cursor: pointer;
}
.drop-area {
  &.active {
  background-color: $white;
  border: 1px solid orange;
  }
}
.preview {
  img {
    max-width: 100px;
    max-height: 100px;
  }
}
@media (max-width: 750px) {
  .direction {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .left-side {
    width: 90%;
    margin-bottom: 24px;
    margin-left: 0px;
  }
  .right-side {
    width: 90%;
    margin-right: 0px;
  }
}
::v-deep {
  .btn-add__custom {
        font-size: 10px;
        letter-spacing: 0.01em;
        border: 1px solid $black !important;
        background-color: #e9e9eb !important;
    }
}
</style>
